import React, { useEffect, useState } from "react";
import { X, Pencil, Trash2, RefreshCcw } from "lucide-react";
import { usePayment } from "../context/PaymentContext.jsx";
import axios from 'axios';


const BASE_URL = process.env.REACT_APP_BASE_URL;

function Successpage({
  response,
  setentriesmodal,
  setSuccess,
  setFile,
  setshowuploadfilemodal,
  showModal,
  selectedCompany,
  departments,
  setresponse,
  entryId,
  timestamp,
  settimestamp
}) {
  const { finalattendancesubmit, attendancefiledatafetch } = usePayment();

  const [rows, setRows] = useState([]);
  const [editingIndex, setEditingIndex] = useState(true);
  const [finalmodal, setfinalmodal] = useState(false);
const [deletedRows, setDeletedRows] = useState([]);
const [showErrors, setShowErrors] = useState(false);
const [deleterowforrecheck, setdeleterowforrecheck] = useState([])
const [showDeleted, setShowDeleted] = useState(false);
const [loading, setloading] = useState(false);



useEffect(() => {
  if (!response) {
    setRows([]);
    return;
  }

  let data = [];

  if (Array.isArray(response.data)) {
    data = response.data;
  } else if (Array.isArray(response.data?.data)) {
    data = response.data.data;
  }

  // ✅ NORMALIZE busEntry
  const normalized = data.map((row) => ({
    ...row,
    busEntry:
      row.busEntry == "TRUE" ||
      row.busEntry == "YES" ||
      row.busEntry == 1,
  }));

  setRows(normalized);
}, [response]);



  /* ---------- VALIDATION ---------- */


  /* ---------- EDIT ---------- */
  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;


    setRows(updated);
  };

  /* ---------- DELETE ---------- */
 const handleDelete = (index) => {
  setDeletedRows((prev) => [...prev, rows[index].phone]); // remember deleted row
  setdeleterowforrecheck((prev) => [...prev, rows[index].phone]);
  setRows((prev) => prev.filter((_, i) => i !== index));
};


  /* ---------- RECHECK ---------- */

  const handleRecheck = async () => {
    const payload = {
      totalRows: rows.length,
      hasAnyError,
      data: rows,

    };

    console.log("timestamps",timestamp);

    try {
      console.log("Timestamp in success",timestamp);
      const token = localStorage.getItem("superadmintoken");

      const apiresponse = await attendancefiledatafetch(
        payload.data,
        selectedCompany,
        token
      );
      if (apiresponse.success == false) {
        showModal(
          "Error",
          `${apiresponse.message}`,
          setresponse(null)
        );

      }
      else {
        setresponse(apiresponse);
        setEditingIndex(null)
        setdeleterowforrecheck([]);
        const time =apiresponse?.finalTimestamp;
        settimestamp(time);
      }


    } catch (error) {
      showModal(
        "Upload Failed",
        "Something went wrong while uploading the file. Please try again."
      );
    }


  };



  /* ---------- CHECKBOX ---------- */
  // const handleCheckboxChange = (index, checked) => {
  //   setAcceptanceMap((prev) => ({
  //     ...prev,
  //     [index]: checked,
  //   }));
  // };

  /* ---------- FLAGS ---------- */
 const hasAnyError =
  !Array.isArray(rows) ||                       // rows is null / undefined / not array
  rows.length === 0 ||                          // no entries found
  rows.some(
    (r) => r.description && r.description.trim() !== ""
  );



  /* ---------- PAYLOAD ---------- */
const buildPayload = () => {
  const validRows = rows.filter(
    (row) => !row.description || row.description.trim() === ""
  );

  return {
    entries: validRows,
  };
};


  ///change date
  const toISODate = (date) => {
    if (!date) return "";
    if (date.includes("T")) return date.split("T")[0];

    const [dd, mm, yyyy] = date.split("-");
    return `${yyyy}-${mm}-${dd}`;
  };

  const toDisplayDate = (isoDate) => {
    if (!isoDate) return "";
    const [yyyy, mm, dd] = isoDate.split("-");
    return `${dd}-${mm}-${yyyy}`;
  };



  /* ---------- SUBMIT ---------- */
  const handleFinalSubmit = async () => {
    const payload = buildPayload();
    console.log("timestamp",timestamp);
    try {
      setloading(true);
      const token = localStorage.getItem("superadmintoken");
      const finalresponse = await axios.post(
        `${BASE_URL}/lenskart-admin/confirm-bulk-mark-entry/`,
        {
          users: payload.entries,
          companyId: selectedCompany,
          entryId,
          deletedRecords:deletedRows,
          finalTimestamp:timestamp
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!finalresponse.data.success) {

        showModal(
          "Error",
          `${finalresponse.data.message}`,
        );
        setresponse(null)
      }
      else if (finalresponse.data.success) {
        setfinalmodal(true);
        setSuccess(true);
         setresponse(finalresponse);
   
  setFile(null);
      }
    } catch (err) {
    }
    finally
    {
      setloading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1200]">
      <div className="bg-gray-100 rounded-lg w-[95%] max-w-7xl h-[85vh] flex flex-col">

        {/* HEADER */}
        <div className="flex justify-between px-6 py-4 bg-white border-b">
          <h2 className="text-xl font-bold">Attendance Details</h2>
          <X
            onClick={() => {
              setentriesmodal(false);
              setFile(null);
            }}
            className="cursor-pointer"
          />
        </div>

        {/* ERROR BANNER */}
        {hasAnyError && (
          <div className="m-4 p-3 bg-red-100 text-red-700 rounded">
            ❌ Resolve all error rows before submitting.
          </div>
        )}

        {/* TABLE */}
        <div className="p-4 overflow-auto flex-1">
          <table className="w-full bg-white border text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="border p-2">Name</th>
                <th className="border p-2">Phone</th>
                <th className="border p-2">Department</th>
                <th className="border p-2">Entry Date</th>
                <th className="border p-2">Entry time</th>
                <th className="border p-2">Bus taken</th>
                <th className="border p-2">Status</th>
                <th className="border p-2">Actions</th>
              </tr>
            </thead>

            <tbody>
              {rows.map((row, index) => {
                const isEditing = editingIndex === index;
                const isError = row.description;

                return (
                  <tr
                    key={index}
                    className={
                      isError
                        ? "bg-red-50 border-l-4 border-red-500"
                        : "bg-green-50 border-l-4 border-green-500"
                    }
                  >
                    {/* {!hasAnyError && (
                      <td className="border p-2 text-center">
                        <input
                          type="checkbox"
                          checked={acceptanceMap[index] || false}
                          onChange={(e) =>
                            handleCheckboxChange(index, e.target.checked)
                          }
                        />
                      </td>
                    )} */}

                    {/* //name */}
                    <td className="border p-2">

                      {row.name}
                    </td>

                    {/* PHONE */}
                    <td className="border p-2">

                      {row.phone}
                    </td>

                    {/* DEPARTMENT DROPDOWN */}
                    <td className="border p-2">
                      {isEditing ? (
                        <select
                          value={row.department || ""}
                          onChange={(e) =>
                            handleChange(index, "department", e.target.value)
                          }
                          className="w-full border px-2 py-1 rounded bg-white"
                        >
                          <option value="">Select Department</option>
                          {departments.map((dept, i) => (
                            <option key={i} value={dept}>
                              {dept}
                            </option>
                          ))}
                        </select>
                      ) : (
                        row.department
                      )}
                    </td>

                    {/* entry date */}
                    <td className="border p-2">
                      {isEditing ? (
                        <input
                          type="date"
                          value={row.entryDate ? toISODate(row.entryDate) : ""}
                          max={new Date().toISOString().split("T")[0]} // disables future dates
                          onChange={(e) =>
                            handleChange(index, "entryDate", toDisplayDate(e.target.value))
                          }
                          className="w-full border px-2 py-1 rounded"
                        />
                      ) : (
                        <span>{row.entryDate || "-"}</span>
                      )}
                    </td>



                    {/* in */}
                    <td className="border p-2">
                      {isEditing ? (
                        <input
                          type="time"
                          value={row.entryTime || ""}
                          step="60"
                          onChange={(e) =>
                            handleChange(index, "entryTime", e.target.value)
                          }
                          className="w-full border px-2 py-1 rounded"
                        />
                      ) : (
                        row.entryTime || "-"
                      )}
                    </td>


 <td className="border p-2">

                   {isEditing ? (
  <select
    value={String(row.busEntry).toUpperCase() === "TRUE" ? "YES" : "NO"}
    onChange={(e) =>
      handleChange(index, "busEntry", e.target.value === "YES" ? "TRUE" : "FALSE")
    }
    className="w-full border px-1 py-1 rounded flex"
  >
    <option value="YES">YES</option>
    <option value="NO">NO</option>
  </select>
) : (
  String(row.busEntry).toUpperCase() === "TRUE" ? "YES" : "NO"
)}

</td>


                    {/* DESCRIPTION */}
                    <td className="border p-2 font-medium">
                      {isError ? (
                        <span className="text-red-600">{row.description}</span>
                      ) : (
                        <span className="text-green-600">✔ Valid</span>
                      )}
                    </td>

                    {/* ACTIONS */}
                    <td className="border p-2 align-middle">
                      <div className="flex items-center justify-center gap-3 h-9">

                        {/* EDIT / CANCEL */}
                        {row?.name?.trim() && (
  <button
    onClick={() => setEditingIndex(isEditing ? null : index)}
    className={`flex items-center justify-center w-8 h-8 rounded
      ${
        isEditing
          ? "text-gray-600 hover:bg-gray-200"
          : "text-blue-600 hover:bg-blue-100"
      }`}
  >
    {isEditing ? <X size={16} /> : <Pencil size={16} />}
  </button>
)}


                        {/* DELETE */}
                        <button
                          onClick={() => handleDelete(index)}
                          className="flex items-center justify-center w-8 h-8 text-red-600 hover:bg-red-100 rounded"
                        >
                          <Trash2 size={16} />
                        </button>

                      </div>
                    </td>


                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* FOOTER */}
        <div className="px-6 py-4 bg-white border-t flex justify-between">
          <button

            onClick={handleRecheck

            }


            className="flex items-center gap-2 bg-yellow-500 text-white px-4 py-2 rounded"
          >
            <RefreshCcw size={16} /> Recheck
          </button>

        {finalmodal && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[1300]">
    <div className="bg-white w-[520px] rounded-2xl shadow-xl p-6 space-y-5">

      {/* HEADER */}
      <h2 className="text-2xl font-bold text-center text-gray-800">
        Submission Details
      </h2>

      {/* SUCCESS */}
      <div className="flex justify-between items-center bg-green-50 border border-green-200 p-4 rounded-lg">
        <span className="font-semibold text-green-700">
          ✅ Successful Entries
        </span>
        <span className="text-lg font-bold text-green-700">
          {response?.data.validEntriesCount || 0}
        </span>
      </div>

      {/* ERRORS */}
      <div className="border border-red-200 rounded-lg">
        <div className="flex justify-between items-center bg-red-50 p-4 rounded-t-lg">
          <span className="font-semibold text-red-700">
            ❌ Error Entries
          </span>

          <div className="flex items-center gap-3">
            <span className="font-bold text-red-700">
              {response?.data.failedEntries?.length || 0}
            </span>

            {response?.data.failedEntries?.length > 0 && (
              <button
                onClick={() => setShowErrors(!showErrors)}
                className="text-sm text-red-600 hover:underline"
              >
                {showErrors ? "Hide" : "View"}
              </button>
            )}
          </div>
        </div>

        {showErrors && (
          <div className="max-h-40 overflow-auto bg-white p-3">
            <ul className="text-sm text-red-600 list-disc ml-5 space-y-1">
              {response?.data.failedEntries?.map((e, i) => (
                <li key={i}>
                  <span className="font-medium">{e.phone}</span>
          {e.reason && (
            <span className="text-gray-600 ml-2">
              — {e.reason}
            </span>
          )}
                  </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* DELETED */}
      <div className="border border-gray-200 rounded-lg">
  <div className="flex justify-between items-center bg-gray-50 p-4 rounded-t-lg">
    <span className="font-semibold text-gray-700">
      🗑️ Deleted Entries
    </span>

    <div className="flex items-center gap-3">
      <span className="text-lg font-bold text-gray-700">
        {deletedRows.length || 0}
      </span>

      {deletedRows.length > 0 && (
        <button
          onClick={() => setShowDeleted(!showDeleted)}
          className="text-sm text-gray-600 hover:underline"
        >
          {showDeleted ? "Hide" : "View"}
        </button>
      )}
    </div>
  </div>

  {showDeleted && (
    <div className="max-h-40 overflow-auto bg-white p-3">
      <ul className="text-sm text-gray-600 list-disc ml-5 space-y-1">
        {deletedRows?.map((phone, i) => (
          <li key={i}>{phone}</li>
        ))}
      </ul>
    </div>
  )}
</div>


      {/* FOOTER */}
      <button
        onClick={() => {
          setfinalmodal(false);
          setShowErrors(false);
          setShowDeleted(false);
          setDeletedRows([]);
          setentriesmodal(false);      
    setSuccess(false);
    setFile(null);
        }}
        className="w-full mt-3 bg-blue-600 hover:bg-blue-700 text-white py-2.5 rounded-lg font-semibold transition"
      >
        Close
      </button>
    </div>
  </div>
)}



          {!hasAnyError ? (
            <button
              onClick={handleFinalSubmit}
              disabled={loading}
              className="bg-green-600 text-white px-4 py-2 rounded"
            >
              Submit
            </button>
          ) : (
            <button
              onClick={() => {
                setentriesmodal(false);
                setshowuploadfilemodal(true);
                setSuccess(false);
                setFile(null);
              }}
              className="bg-red-600 text-white px-4 py-2 rounded"
            >
              Reupload File
            </button>
          )}
        </div>
      </div>
    </div>
  );
  
}


export default Successpage;


